<template>
  <ZccSearchSelect
    id="vehicle"
    :model-value="modelValue"
    @update:model-value="onInput"
    :options="options"
    :selectLabel="'selecteren'"
    :deselectLabel="'deselecteren'"
    :selectedLabel="'geselecteerd'"
    :placeholder="placeholder"
    :placeholder-is-selected="placeholderSelected"
    class="font-extrabold text-4xl bg-transparent text-center"
    :text-color="textColor"
    :loading="loading"
  >
  </ZccSearchSelect>
</template>

<script setup lang="ts">
import ZccSearchSelect from "./generic/ZccSearchSelect.vue";

import { SelectOption } from "@planbord/shared/models";

const emit = defineEmits<{ (e: "update:modelValue", value: unknown): void }>();
defineProps<{
  label?: string;
  options: SelectOption[];
  loading?: boolean;
  modelValue: unknown;
  textColor: string;
  placeholder: string | undefined;
  placeholderSelected: boolean;
}>();
function onInput(value: unknown) {
  emit("update:modelValue", value);
}
</script>
